// extracted by mini-css-extract-plugin
module.exports = {"modal-wrapper":"Draggable_modal-wrapper__3ZjDA","modal-overlay":"Draggable_modal-overlay__33QGj"};